import { defineComponent as _defineComponent } from 'vue'
import { Trade, tradeStatusBadges, TradeStatus, tradeStateBadges, TradeState } from 'ah-api-gateways';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeStatusCell',
  props: {
    item: null,
    showIcon: { type: [Boolean, String], default: true }
  },
  setup(__props: any) {

const props = __props as { item: Trade, showIcon: boolean | string };



const isTradeRejectedOrCanceled = computed(() => {
  return (
    [TradeStatus.REJECTED, TradeStatus.CANCELED].includes(props.item.status) ||
    [TradeState.CLOSED_REJECTED, TradeState.CLOSED_CANCELED].includes(props.item.state)
  );
});

const tradeStatusClass = computed(() => tradeStatusBadges[props.item.status]?.class);

const tradeStatus = computed(() => tradeStatusBadges[props.item.status]?.label);

const tradeStateClass = computed(() => tradeStateBadges[props.item.state]?.class);

const tradeState = computed(() => tradeStateBadges[props.item.state]?.label);

const status = computed(() => {
  return tradeStatus.value || tradeState.value || 'Unknown';
});

const tradeClass = computed(() => {
  return tradeStatusClass.value || tradeStateClass.value;
});

return { __sfc: true,props, isTradeRejectedOrCanceled, tradeStatusClass, tradeStatus, tradeStateClass, tradeState, status, tradeClass }
}

})